import { createFileRoute } from '@tanstack/react-router'
import { RulesTab } from '@/features/settings'

/** C-09 Booking rules. */
export const Route = createFileRoute('/_authed/clinics/$clinicId/settings/booking/rules')({
  component: RulesTab,
})
